import React from "react";
import {PlusOutlined} from "@ant-design/icons";

import {ActionButtonsContainer} from "./ActionButtons.styles";
import {CustomButton} from "../../_defaultComponents/CustomButton/CustomButton";
import {Button, Tooltip} from "antd";

const ActionButtons = ({recall, filters = {}, loading = false, disabled = false}) => {
    return (
        <ActionButtonsContainer>
            <Tooltip title={"Ara"}>
                <Button
                    type="primary"
                    data-testid="searchAvailableCourierButton"
                    onClick={recall}
                    disabled={loading || disabled || !Boolean(filters?.subcompanyId)}
                >
                    {loading ? "Yükleniyor" : "Ara"}
                </Button>
            </Tooltip>
        </ActionButtonsContainer>
    );
};

export default ActionButtons;
